<template>
  <div class="container-book">
    <div class="tab-trim">
      <button @click="changeBook(1)" :class="trim === 1 ? 'active' : ''">Trimestre 1</button>
      <button @click="changeBook(2)" :class="trim === 2 ? 'active' : ''">Trimestre 2</button>

      <div class="language-switch">
        <button
          v-if="hasMisionPreescolar"
          @click="changeLanguage('spanish')"
          :class="currentLanguage === 'spanish' ? 'active' : ''"
          class="btn-spanish-container"
        >
          <img src="../assets/img/mexico.png" class="btn-spanish" />
        </button>
        <button
          v-if="hasMissionPreK"
          @click="changeLanguage('english')"
          :class="currentLanguage === 'english' ? 'active' : ''"
          class="btn-english-container"
        >
          <img src="../assets/img/usa.png" class="btn-english" />
        </button>
      </div>
    </div>
    <a class="backBtn" :href="`/#/preschool`">
      <img src="/img/back-icon.png" />
    </a>
    <div class="screen-container-book">
      <iframe
        :src="getIframeUrl(trim, missionId, currentLanguage)"
        frameborder="0"
        width="100%"
        height="100%"
        id="book"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
import Auth from '../services/Auth';
import NProgress from 'nprogress';

export default {
  name: 'LibroLecturaPreschool',
  data() {
    return {
      trim: 1,
      currentUser: null,
      essentials: [],
      gradeData: null,
      academicGradeId: null,
      hasMissionPreK: false,
      hasMisionPreescolar: false,
      currentLanguage: 'spanish'
    };
  },
  computed: {
    missionId() {
      return this.$route.params.missionId;
    }
  },
  async mounted() {
    await this.fetchCurrentUser();
  },
  async created() {
    NProgress.done();
  },
  methods: {
    async fetchCurrentUser() {
      try {
        const foundStudent = this.$store.state.session.currentUser.roles.find(
          element => element.role.code === 'STUDENT'
        );
        if (foundStudent) {
          this.gradeData = this.$store.state.session.currentGrade.data;
          this.essentials = this.gradeData.essentials;
          this.academicGradeId = this.gradeData.academicGrade.id;
          this.checkMissionTypes();
          if (this.hasMissionPreK && this.hasMisionPreescolar) {
            this.currentLanguage = 'spanish'; 
          } else if (this.hasMissionPreK) {
            this.currentLanguage = 'english';
          } else if (this.hasMisionPreescolar) {
            this.currentLanguage = 'spanish';
          } else {
            console.log('El usuario no tiene acceso al contenido de misión preescolar/pre-k');
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    changeBook(trim) {
      this.trim = trim;
    },
    changeLanguage(language) {
      this.currentLanguage = language;
    },
    logout() {
      Auth.logout();
    },
    checkMissionTypes() {
      if (this.essentials) {
        const essentialsList = this.essentials.map(item => item.toLowerCase());
        this.hasMissionPreK = essentialsList.some(item => item.includes('mission pre-k'));
        this.hasMisionPreescolar = essentialsList.some(item => item.includes('misión preescolar'));
        
        if (this.hasMissionPreK && this.hasMisionPreescolar) {
          console.log('El usuario tiene Mission Pre-K y Misión Preescolar.');
        } else if (this.hasMissionPreK) {
          console.log('El usuario tiene Mission Pre-K.');
        } else if (this.hasMisionPreescolar) {
          console.log('El usuario tiene Misión Preescolar.');
        } else {
          console.log('El usuario no tiene Mission Pre-K ni Misión Preescolar.');
        }
      }
    },
    getIframeUrl(trim, missionId, language) {
      let adjustedMissionId;
      let iframeUrl;

      if (language === 'english') {
        if (missionId.toLowerCase() === 'pf') {
          adjustedMissionId = 'PF';
        } else if (['1', '2', '3'].includes(missionId)) {
          adjustedMissionId = `K${missionId}`;
        } else {
          adjustedMissionId = missionId.toUpperCase();
        }

        iframeUrl = `https://storage.googleapis.com/mision-libros-digitales/preschool/LEC_ENG/Trim${trim}/MP_LEC_ENG_${adjustedMissionId}_TRIM${trim}_00_BOOK_PLATAFORMA/index.html`;
      } else {
        if (missionId === 'PF') {
          adjustedMissionId = `PF`;
        } else {
          adjustedMissionId = `K${missionId}`;
        }

        iframeUrl = `https://storage.googleapis.com/mision-libros-digitales/Alumnos/4Ed/preschool/${missionId}/TRIM${trim}/MP_LEC_${adjustedMissionId}_TRIM${trim}_00_BOOK_PLATAFORMA/index.html`;
      }

      return iframeUrl;
    }
  }
};
</script>
<style lang="scss">
.container-book {
  .tab-trim {
    display: flex;
    position: absolute;
    top: 0;
    padding: 0;
    margin: 0 0 0 0;
    border-bottom: 2px solid #98d3fd;
    width: 50%;
    button {
      color: #fff;
      font-family: Montserrat;
      font-weight: 800;
      font-size: 21px;
      padding: 7px 16px;
      background: #040403c9;
      margin: 0 5px;
      text-shadow: 1.5px 1px #070704a1;
      border: 1px solid white;
      height: 50px;
    }
    button:hover {
      background: #98d3fd;
    }
    .active {
      background: #98d3fd;
    }
  }
}

.language-switch button img {
  width: 50px !important;
  height: 50px !important;
  object-fit: cover;
}

.selectTrim {
  position: absolute;
  left: 7px;
  width: 139px;
  height: auto;
  top: 9px;
  z-index: 9999;
  background: #6b94b1;
  color: #fff;
  border: 0;
  border-radius: 5px;
  /* padding-left: 7px; */
  text-align: center;
  padding: 9px 0;
}
.selectTrim:checked {
  border-radius: 0;
}
select option {
  margin: 40px;
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
  border-radius: 5px;
}
select:focus + .focus {
  position: absolute;
  top: -1px;
  left: -1px;
  right: -1px;
  bottom: -1px;
  border: 2px solid var(--select-focus);
  border-radius: 60px;
}
#app #fbToolBar{
  background: #fff;
}
.screen-container-book {
  width: 100vw;
  height: 100vh;
  #book {
    width: 100%;
    height: 100%;
    height: calc(100vh - 50px);
    margin-top: 50px;
  }
}
.backgroundDesk {
  // background-image: url('/img/new/backgroundLoginDesk.png');
  height: 100vh;
}
.backgroundTable {
  // background-image: url('/img/new/containerLogin.png'); 
  background-size: 100% auto; 
  background-repeat: no-repeat; 
  background-position: center center;
  padding: 9.5vh 0;
}
.spacecraft-container-glass {
  min-width: 100%;
  min-height: 100vh;
  max-height: 100vh;
  padding-top: 1rem !important;
  padding-bottom: 0rem;
  background-position: 50% 50%;
  background-image: url('/img/backgroundSpacecraft.png');
  background-size: cover;
  display: flex;
  align-items: center;
}

.mission-screen {
  border-style: solid;
  border-color: #17202A;
  border-width: 20px;
  border-radius: 50px;
  min-width: 93%;
  min-height: 95vh;
  margin: auto;
  padding-top: 0;
  padding-bottom: 0rem;
  padding-left: 2rem;
  background-image: url('/img/glass.png');
  background-size: cover;
}

.bookContainer {
  height: 81vh;
  min-height: 50vh;
  width: 100%;
}
</style>